export default __webpack_public_path__ + "static/home-hand-04a9bb86a53befaa98621ae7918bf6ec.gif";